const ATTRIBUTION_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'ref',
  'gclid',
  'fbclid',
] as const

const DIRECT_SOURCE = 'direct'

export type TrialSource = Record<string, string>

const readAttribution = (searchParams: URLSearchParams): TrialSource => {
  const attribution: TrialSource = {}
  for (const param of ATTRIBUTION_PARAMS) {
    const value = searchParams.get(param)
    if (value) attribution[param] = value
  }
  if (document.referrer) attribution.referrer = document.referrer
  return attribution
}

// A typed URL carries no attribution at all, so it gets its own bucket instead of none.
export const readTrialSource = (searchParams: URLSearchParams): TrialSource => {
  const attribution = readAttribution(searchParams)
  const isDirect = Object.keys(attribution).length === 0
  return {
    ...attribution,
    landing_path: window.location.pathname,
    ...(isDirect && { source: DIRECT_SOURCE }),
  }
}
